import axios from 'axios'
import config from '../config'
import store from '../store'
import moment from 'moment'

export default {
  request (services, method, uri, data = null, responseType = 'json') {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    var url = ''
    if (config.environment === 'Local') {
      switch (services) {
        case 'Account':
          url = config.serverAccountURI + uri
          break
        case 'Guest':
          url = config.serverGuestURI + uri
          break
        case 'Sales':
          url = config.serverSalesURI + uri
          break
        case 'POS':
          url = config.serverPOSURI + uri
          break
        case 'Payment':
          url = config.serverPaymentURI + uri
          break
        case 'Gate':
          url = config.serverGateURI + uri
          break
        case 'Reservation':
          url = config.serverReservationURI + uri
          break
        case 'Golf':
          url = config.serverGolfURI + uri
          break
        default:
          url = config.serverDevelopmentURI + uri
          break
      }
    // } else if (config.environment === 'Development') {
    //   url = config.serverDevelopmentURI + uri
    // } else if (config.environment === 'Production') {
    //   url = config.serverProductionURI + uri
    } else {
      url = uri
    }

    if (!url.includes('UserId=')) {
      if (url.includes('?')) {
        url = url + '&UserId=' + (store.getters.user ? store.getters.user.id : 0)
      } else {
        url = url + '?UserId=' + (store.getters.user ? store.getters.user.id : 0)
      }
    }

    if (url.includes('?')) {
      url = url + '&Localization=UTC' + moment().format('ZZ')
    } else {
      url = url + '?Localization=UTC' + moment().format('ZZ')
    }

    let headerReq = null
    if (config.environment === 'Local') {
      headerReq = {
        'Authorization': store.getters.token
      }
    }

    if (config.environment === 'Development') {
      headerReq = {
        'Authorization': store.getters.token,
        'x-api-key': config.xKeyDev
      }
    }

    if (config.environment === 'Production') {
      headerReq = {
        'Authorization': store.getters.token,
        'x-api-key': config.xKeyPrd
      }
    }

    return axios({
      method: method,
      url: url,
      headers: headerReq,
      data: data,
      responseType: responseType
    })
  },

  requestWithFile (services, method, uri, data = null, responseType = 'json') {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    var url = ''
    if (config.environment === 'Local') {
      switch (services) {
        case 'Account':
          url = config.serverAccountURI + uri
          break
        case 'Guest':
          url = config.serverGuestURI + uri
          break
        case 'Sales':
          url = config.serverSalesURI + uri
          break
        case 'POS':
          url = config.serverPOSURI + uri
          break
        case 'Payment':
          url = config.serverPaymentURI + uri
          break
        case 'Gate':
          url = config.serverGateURI + uri
          break
        case 'Reservation':
          url = config.serverReservationURI + uri
          break
        default:
          url = config.serverDevelopmentURI + uri
          break
      }
    // } else if (config.environment === 'Development') {
    //   url = config.serverDevelopmentURI + uri
    // } else if (config.environment === 'Production') {
    //   url = config.serverProductionURI + uri
    } else {
      url = uri
    }

    if (!url.includes('UserId=')) {
      if (url.includes('?')) {
        url = url + '&UserId=' + (store.getters.user ? store.getters.user.id : 0)
      } else {
        url = url + '?UserId=' + (store.getters.user ? store.getters.user.id : 0)
      }
    }

    if (url.includes('?')) {
      url = url + '&Localization=UTC' + moment().format('ZZ')
    } else {
      url = url + '?Localization=UTC' + moment().format('ZZ')
    }
    let headerReq = null
    if (config.environment === 'Local') {
      headerReq = {
        'Authorization': store.getters.token,
        'Content-Type': 'multipart/form-data'
      }
    }

    if (config.environment === 'Development') {
      headerReq = {
        'Authorization': store.getters.token,
        'Content-Type': 'multipart/form-data',
        'x-api-key': config.xKeyDev
      }
    }

    if (config.environment === 'Production') {
      headerReq = {
        'Authorization': store.getters.token,
        'Content-Type': 'multipart/form-data',
        'x-api-key': config.xKeyPrd
      }
    }

    return axios({
      method: method,
      url: url,
      headers: headerReq,
      data: data,
      responseType: responseType
    })
  },

  getBaseUrl (services, uri) {
    var url = ''
    if (config.environment === 'Local') {
      switch (services) {
        case 'MasterData':
          url = config.serverMasterDataURI + uri
          break
        case 'Account':
          url = config.serverAccountURI + uri
          break
        case 'Guest':
          url = config.serverGuestURI + uri
          break
        case 'Sales':
          url = config.serverSalesURI + uri
          break
        case 'POS':
          url = config.serverPOSURI + uri
          break
        default:
          url = config.serverDevelopmentURI + uri
          break
      }
    } else if (config.environment === 'Development') {
      url = uri
    } else if (config.environment === 'Production') {
      url = uri
    } else {
      url = ''
    }

    return url
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js